import { Component } from '@angular/core';
import { GlobalEMailTemplate } from 'src/modules/enaio/netgen/GlobalEMailTemplate';
import { Objects } from 'src/modules/utils/shared/objects';
import { EntityDefinition } from '../../models/entity-definition.model';
import { TableData } from '../../models/table-data.model';
import { TableRow } from '../../models/table-row.model';
import { TableCellType } from '../../netgen/TableCellType';
import { TableColumn } from '../../netgen/TableColumn';
import { AdminBaseListComponent } from '../admin-base-list/admin-base-list.component';

@Component({
    selector: 'app-edit-global-email-templates',
    templateUrl: '../../../sm-base/components/admin-base-list/admin-base-list.component.html',
    standalone: false
})
export class EditGlobalEMailTemplatesComponent extends AdminBaseListComponent<GlobalEMailTemplate> {
 
    static staticDefinition = Objects.fromPlain(EntityDefinition<GlobalEMailTemplate>, {
        type: GlobalEMailTemplate,
        name: "E-Mail-Vorlage",
        namePlural: "E-Mail-Vorlagen",
        category: "Allgemein",
        icon: "fas fa-envelope",
        apiEndpoint: "api/app/globalEMailTemplate",
        adminListUrl: "/base2/admin/editGlobalEMailTemplates"
    });

    definition = Objects.with(Objects.with(Objects.fromPlain(EntityDefinition<GlobalEMailTemplate>, EditGlobalEMailTemplatesComponent.staticDefinition), "canInsert", this.app.mainConfig.globalEmailTemplatesAllowAdd), "canDelete", this.app.mainConfig.globalEmailTemplatesAllowAdd);
  
    getTable(): TableData {
        return new TableData([
            new TableColumn("title", "Titel", TableCellType.string, -1),
            new TableColumn("subject", "Betreff", TableCellType.string, -1)
        ], this.listData.map(o => new TableRow("", o, {
            title: o.title,
            subject: o.subject
        }, {
            canDeleteInternal: !o.isRequired
        })), ["title"]);
    }
}